var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow-right"},React.createElement("path",{"id":"Vector","d":"M4 11H16.17L10.58 5.41L12 4L20 12L12 20L10.59 18.59L16.17 13H4V11Z"})));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
